import $ from "jquery/src/jquery"

import "../sass/app.scss"
import "./gc_session_cookies"   
import "./mobile_check"
import "./header_nav"
import "./icons_numbers"
import "./client_carousel"
import "./dynamics_form"
import "./coverage_plugin"
import "./check_coverage"
import "./persona_carousel"
import "./video_modal"
import "./video_fullWidth"
import "./post_archive"
import "./ninja_forms"
import "./hero_section"
import "./language_picker"
import "./mobile_navigation"
import "./mobile_navigation"
import "./address_search"
import "./global_coverage_search"
import "./snow"
import "./slick"
import "./snow-company-search"
import "./animated_text"
import "./sticky_nav"
import "./download_section"
import "./contact_section"
import "./usp-link"
import "./smb_journey"